import { createSelector } from 'reselect';
import { AUTH_PREFIX } from 'app/models/auth/constants';
import { ENTITY_PREFIX, REMOTE_PREFIX } from 'app/remote/constants';
import { User, UserExternalAuth } from 'app/constants/schemas';
import { getEntityOfType } from 'app/models/entities/selectors';

// We get the current user from the remote store in case we make some local
// changes which might affect `getAuthUser`.
//
// There's also a circular reference somewhere with entities/selectors which is
// why I couldn't put it there otherwise this function becomes undefined.
const getAllUsersRemote = (state) => state.getIn([REMOTE_PREFIX, ENTITY_PREFIX, User.storePrefix]);

const authSelector = state => state && state.get(AUTH_PREFIX);

export const getAuthUser = createSelector([
  authSelector,
  getAllUsersRemote,
], (state, allUsers) =>
  state && state.userId && allUsers.get(state.userId),
);

export const getCurrentUserAbilities =
  createSelector(authSelector, (auth) => auth.authenticatedAbilities);

export const isAuthenticatedSelector = createSelector(getAuthUser, user => !!user);

export const getValidUntil = createSelector(authSelector, auth => auth.validUntil);

export const isTeacher = (user) => user && !!user.teacher;

export const isStaffMember = (user) => user && !!user.staffMember;

export const getUserExternalAuths = createSelector([
  state => state,
  getAuthUser,
], (state, authUser) =>
    authUser.userExternalAuths.map((authId) => getEntityOfType(state, UserExternalAuth, authId)),
);
